import * as React from 'react';
import { RouteChildrenProps } from 'react-router-dom';

import { config } from 'web-frontend/lib';
import { HeaderPane } from 'web-frontend/components';
import { ProductsPane, FaqPane, GetStartedPane, TestimonyPane } from './components';
import { useHeaderLinks } from 'web-shared/lib';

const getStartedLink = config.site.banners && config.site.banners.length
    ? config.site.banners[0].linkUrl : '';

const LandingPage: React.FC<RouteChildrenProps> = function () {
    if(config.client.id !== 1047) {
        useHeaderLinks([
            { name: 'FAQs', href: '/questions' },
        ]);
    }

    return <div style={{ height: '100%' }}>
        <HeaderPane banners={config.site.banners} />
        <ProductsPane features={config.site.features} featureSummaryText={config.featureSummaryText} />
        {config.faqs.length ? <FaqPane faqs={config.faqs} /> : null}
        {config.site.type !== 'paycheck' ? <GetStartedPane text={config.getStartedText} url={getStartedLink} /> : null}
        <TestimonyPane testimonies={config.testimonies} />
    </div>;
};

export default LandingPage;
